import Vehicle from "./Vehicle";

export default Vehicle;